<script lang="ts" setup>
const props = withDefaults(defineProps<{
    enabled?: boolean;
    top?: boolean;
    hideScroll?: boolean;
}>(), {
    enabled: true,
    top: false,
    hideScroll: false
});

const $attrs = useAttrs();
const attrs = (): Record<string, any> => only($attrs, 'class', 'style');

const scroll = ref<HTMLDivElement | null>(null);
const left = ref(false);
const right = ref(false);

const scrollBar = inject<Ref<HTMLDivElement | null>>('scrollBar', null);

const handleScroll = (): void =>
{
    if (props.enabled)
    {
        left.value = scroll.value?.scrollLeft > 0;
        right.value = scroll.value?.scrollWidth - (scroll.value?.scrollLeft + scroll.value?.clientWidth) > 0;
    }
    else
    {
        left.value = false;
        right.value = false;
    }
};

onMounted(() =>
{
    handleScroll();

    nextTick(() =>
    {
        handleScroll();
    });

    if (scroll.value)
    {
        scroll.value.addEventListener('scroll', handleScroll);
    }
});

onUnmounted(() =>
{
    if (scroll.value)
    {
        scroll.value.removeEventListener('scroll', handleScroll);
    }
});

const onScrollContent = (e: Event) =>
{
    const left = (e.target as HTMLDivElement).scrollLeft;

    if (!scrollBar.value) return;

    scrollBar.value.parentElement.scrollLeft = left;
};
</script>

<template>
    <div v-bind="attrs()" :class="{ responsive: enabled, top: top, 'scroll-before': left, 'scroll-after': right }">
        <div ref="scroll" :class="{ 'wrapper scroll light': enabled, 'scroll-hide': hideScroll }" @scroll="onScrollContent">
            <div class="inner">
                <slot />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.responsive {
    position: relative;
    margin: -1px 0;

    &::before,
    &::after {
        display: none;
        position: absolute;
        top: 50%;
        margin-top: -6px;
        height: 9px;
        font-size: 10px;
        color: var(--bs-body-color);
    }

    &.scroll-before::before {
        display: block;
        left: -10px;
        font-family: var(--fa-font-family);
        font-weight: 900;
        line-height: 1;
        content: '\f104';
    }

    &.scroll-after::after {
        display: block;
        right: -10px;
        font-family: var(--fa-font-family);
        font-weight: 900;
        line-height: 1;
        content: '\f105';
    }

    .scroll-hide {
        -ms-overflow-style: none;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    & > .wrapper {
        display: block;
        width: 100%;
        height: 100%;

        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        box-sizing: content-box;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
    }
}
</style>
